import service from '@/utils/server';

const modName='/bd/weigh/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const exportData = data => {
  return service({
    url: modName + 'export',
    method: 'post',
    responseType: 'blob',
    data
  });
};


export const details = data => {
  return service({
    url: modName + 'details',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/bd/weighingSlipPrinting/api/index.js